import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AlertTriangle, Loader2 } from "lucide-react";
import { api } from "../lib/api";

const TITLES = {
  privacy: "Privacy Policy",
  terms: "Terms & Conditions",
  refunds: "Refund & Return Policy",
};

export default function Legal() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    setLoading(true);
    setErr(null);
    api.get(`/legal/${slug}`)
      .then((r) => setDoc(r.data))
      .catch(() => setErr("Not found"))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return (
    <div className="max-w-3xl mx-auto px-4 py-24 text-center" style={{ color: "var(--text-muted)" }}>
      <Loader2 className="w-6 h-6 mx-auto animate-spin mb-2" />
      Opening the page…
    </div>
  );
  if (err || !doc) return (
    <div className="max-w-3xl mx-auto px-4 py-24 text-center" style={{ color: "var(--text-muted)" }}>
      That legal page is unavailable.
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 lg:py-20" data-testid={`legal-page-${slug}`}>
      <div className="eyebrow mb-2">Legal</div>
      <h1 className="font-serif text-4xl sm:text-5xl mb-4" style={{ color: "var(--burgundy)" }}>
        {doc.title || TITLES[slug]}
      </h1>
      {doc.is_draft && (
        <div className="mb-6 rounded-lg border px-4 py-3 text-xs flex items-start gap-2" style={{ background: "var(--bg-cream-card)", borderColor: "var(--gold-soft)", color: "var(--text-obsidian)" }} data-testid="legal-draft-banner">
          <AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: "var(--gold-dark)" }} />
          <span><strong>Draft — requires owner review.</strong> This placeholder language has not been legally reviewed. Do not rely on it as binding policy until an Administrator approves the final copy.</span>
        </div>
      )}
      <article
        className="prose max-w-none font-serif text-base leading-relaxed"
        style={{ color: "var(--text-obsidian)", whiteSpace: "pre-line" }}
      >
        {doc.body}
      </article>
      <div className="mt-10 text-xs" style={{ color: "var(--text-muted)" }}>
        Last updated: {(doc.updated_at || "").slice(0, 10)}
      </div>
    </div>
  );
}
